export default [
  {
    path: '/activity-20260227-main',
    component: () => import('./Page.vue'),
    meta: { title: '元宵喜乐会', id: 21 },
  },
  {
    path: '/activity-20260227-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '元宵喜乐会-规则', id: 21 },
  },
]
